import { Base } from "../Base";
export class Class extends Base {
    base;
    class = "inverse";
    _name;
    get name() {
        return (this._name ??= `Inverse<${this.base.name}>`);
    }
    get definition() {
        return Object.assign(super.definition, { base: this.base.definition });
    }
    constructor(base, name) {
        super();
        this.base = base;
        this._name = name;
    }
    is(value) {
        return !this.base.is(value);
    }
    static create(base, name) {
        return new Class(base, name);
    }
}
//# sourceMappingURL=Class.js.map